import React from "react";
import * as s from "./box.module.less"

const ProblemBox = ({
	title,
	description,
}) => {
	return (
		<div className={s.problemBox}>
			<div className={s.x}>X</div>
			<div className={s.text}>
				<h4>{title}</h4>
				<p>{description}</p>
			</div>
		</div>
	)
}
export default ProblemBox;
